// tslint:disable
// This file is generated by generateBalancingMaps script.
// Please don't edit it manually.
// prettier-ignore
export var buildingsByRecipeId = new Map([
    [1, [7]],
    [283, [7]],
    [11, [7]],
    [293, [7]],
    [21, [7]],
    [303, [7]],
    [31, [7]],
    [313, [7]],
    [352, [7]],
    [362, [7]],
    [372, [7]],
    [382, [7]],
    [3730, [7]],
    [3740, [7]],
    [213, [7]],
    [223, [7]],
    [3710, [7]],
    [141, [7, 30, 155]],
    [212, [7, 30, 155]],
    [936, [7, 30, 155]],
    [2, [7]],
    [284, [7]],
    [12, [7]],
    [294, [7]],
    [22, [7]],
    [304, [7]],
    [32, [7]],
    [314, [7]],
    [353, [7]],
    [363, [7]],
    [373, [7]],
    [383, [7]],
    [3731, [7]],
    [3741, [7]],
    [214, [7]],
    [224, [7]],
    [3711, [7]],
    [3, [7]],
    [285, [7]],
    [13, [7]],
    [295, [7]],
    [23, [7]],
    [305, [7]],
    [33, [7]],
    [315, [7]],
    [354, [7]],
    [364, [7]],
    [374, [7]],
    [384, [7]],
    [3732, [7]],
    [3742, [7]],
    [215, [7]],
    [225, [7]],
    [3712, [7]],
    [4, [7]],
    [286, [7]],
    [14, [7]],
    [296, [7]],
    [24, [7]],
    [306, [7]],
    [34, [7]],
    [316, [7]],
    [355, [7]],
    [365, [7]],
    [375, [7]],
    [385, [7]],
    [3733, [7]],
    [3743, [7]],
    [216, [7]],
    [226, [7]],
    [3713, [7]],
    [5, [7]],
    [287, [7]],
    [15, [7]],
    [297, [7]],
    [25, [7]],
    [307, [7]],
    [35, [7]],
    [317, [7]],
    [356, [7]],
    [366, [7]],
    [376, [7]],
    [386, [7]],
    [3734, [7]],
    [3744, [7]],
    [217, [7]],
    [227, [7]],
    [3714, [7]],
    [6, [7]],
    [288, [7]],
    [16, [7]],
    [298, [7]],
    [26, [7]],
    [308, [7]],
    [36, [7]],
    [318, [7]],
    [357, [7]],
    [367, [7]],
    [377, [7]],
    [387, [7]],
    [3735, [7]],
    [3745, [7]],
    [218, [7]],
    [228, [7]],
    [3715, [7]],
    [7, [7]],
    [289, [7]],
    [17, [7]],
    [299, [7]],
    [27, [7]],
    [309, [7]],
    [37, [7]],
    [319, [7]],
    [358, [7]],
    [368, [7]],
    [378, [7]],
    [388, [7]],
    [3736, [7]],
    [3746, [7]],
    [219, [7]],
    [229, [7]],
    [3716, [7]],
    [8, [7]],
    [290, [7]],
    [18, [7]],
    [300, [7]],
    [28, [7]],
    [310, [7]],
    [38, [7]],
    [320, [7]],
    [359, [7]],
    [369, [7]],
    [379, [7]],
    [389, [7]],
    [3737, [7]],
    [3747, [7]],
    [220, [7]],
    [230, [7]],
    [3717, [7]],
    [9, [7]],
    [291, [7]],
    [19, [7]],
    [301, [7]],
    [29, [7]],
    [311, [7]],
    [39, [7]],
    [321, [7]],
    [360, [7]],
    [370, [7]],
    [380, [7]],
    [390, [7]],
    [3738, [7]],
    [3748, [7]],
    [221, [7]],
    [231, [7]],
    [3718, [7]],
    [10, [7]],
    [292, [7]],
    [20, [7]],
    [302, [7]],
    [30, [7]],
    [312, [7]],
    [40, [7]],
    [322, [7]],
    [361, [7]],
    [371, [7]],
    [381, [7]],
    [391, [7]],
    [3739, [7]],
    [3749, [7]],
    [222, [7]],
    [232, [7]],
    [3719, [7]],
    [596, [30]],
    [606, [30]],
    [616, [30]],
    [626, [30]],
    [636, [30]],
    [646, [30]],
    [656, [30]],
    [666, [30]],
    [676, [30]],
    [686, [30]],
    [696, [30]],
    [706, [30]],
    [3750, [30]],
    [3760, [30]],
    [736, [30]],
    [746, [30]],
    [3720, [30]],
    [597, [30]],
    [607, [30]],
    [617, [30]],
    [627, [30]],
    [637, [30]],
    [647, [30]],
    [657, [30]],
    [667, [30]],
    [677, [30]],
    [687, [30]],
    [697, [30]],
    [707, [30]],
    [3751, [30]],
    [3761, [30]],
    [737, [30]],
    [747, [30]],
    [3721, [30]],
    [598, [30]],
    [608, [30]],
    [618, [30]],
    [628, [30]],
    [638, [30]],
    [648, [30]],
    [658, [30]],
    [668, [30]],
    [678, [30]],
    [688, [30]],
    [698, [30]],
    [708, [30]],
    [3752, [30]],
    [3762, [30]],
    [738, [30]],
    [748, [30]],
    [3722, [30]],
    [599, [30]],
    [609, [30]],
    [619, [30]],
    [629, [30]],
    [639, [30]],
    [649, [30]],
    [659, [30]],
    [669, [30]],
    [679, [30]],
    [689, [30]],
    [699, [30]],
    [709, [30]],
    [3753, [30]],
    [3763, [30]],
    [739, [30]],
    [749, [30]],
    [3723, [30]],
    [600, [30]],
    [610, [30]],
    [620, [30]],
    [630, [30]],
    [640, [30]],
    [650, [30]],
    [660, [30]],
    [670, [30]],
    [680, [30]],
    [690, [30]],
    [700, [30]],
    [710, [30]],
    [3754, [30]],
    [3764, [30]],
    [740, [30]],
    [750, [30]],
    [3724, [30]],
    [601, [30]],
    [611, [30]],
    [621, [30]],
    [631, [30]],
    [641, [30]],
    [651, [30]],
    [661, [30]],
    [671, [30]],
    [681, [30]],
    [691, [30]],
    [701, [30]],
    [711, [30]],
    [3755, [30]],
    [3765, [30]],
    [741, [30]],
    [751, [30]],
    [3725, [30]],
    [602, [30]],
    [612, [30]],
    [622, [30]],
    [632, [30]],
    [642, [30]],
    [652, [30]],
    [662, [30]],
    [672, [30]],
    [682, [30]],
    [692, [30]],
    [702, [30]],
    [712, [30]],
    [3756, [30]],
    [3766, [30]],
    [742, [30]],
    [752, [30]],
    [3726, [30]],
    [603, [30]],
    [613, [30]],
    [623, [30]],
    [633, [30]],
    [643, [30]],
    [653, [30]],
    [663, [30]],
    [673, [30]],
    [683, [30]],
    [693, [30]],
    [703, [30]],
    [713, [30]],
    [3757, [30]],
    [3767, [30]],
    [743, [30]],
    [753, [30]],
    [3727, [30]],
    [604, [30]],
    [614, [30]],
    [624, [30]],
    [634, [30]],
    [644, [30]],
    [654, [30]],
    [664, [30]],
    [674, [30]],
    [684, [30]],
    [694, [30]],
    [704, [30]],
    [714, [30]],
    [3758, [30]],
    [3768, [30]],
    [744, [30]],
    [754, [30]],
    [3728, [30]],
    [605, [30]],
    [615, [30]],
    [625, [30]],
    [635, [30]],
    [645, [30]],
    [655, [30]],
    [665, [30]],
    [675, [30]],
    [685, [30]],
    [695, [30]],
    [705, [30]],
    [715, [30]],
    [3759, [30]],
    [3769, [30]],
    [745, [30]],
    [755, [30]],
    [3729, [30]],
    [71, [9]],
    [142, [9]],
    [152, [9]],
    [162, [9]],
    [72, [9]],
    [143, [9]],
    [153, [9]],
    [163, [9]],
    [73, [9]],
    [144, [9]],
    [154, [9]],
    [164, [9]],
    [74, [9]],
    [145, [9]],
    [155, [9]],
    [165, [9]],
    [75, [9]],
    [146, [9]],
    [156, [9]],
    [166, [9]],
    [76, [9]],
    [147, [9]],
    [157, [9]],
    [167, [9]],
    [77, [9]],
    [148, [9]],
    [158, [9]],
    [168, [9]],
    [78, [9]],
    [149, [9]],
    [159, [9]],
    [169, [9]],
    [79, [9]],
    [150, [9]],
    [160, [9]],
    [170, [9]],
    [80, [9]],
    [151, [9]],
    [161, [9]],
    [171, [9]],
    [1005, [32]],
    [1015, [32]],
    [1025, [32]],
    [1035, [32]],
    [1006, [32]],
    [1016, [32]],
    [1026, [32]],
    [1036, [32]],
    [1007, [32]],
    [1017, [32]],
    [1027, [32]],
    [1037, [32]],
    [1008, [32]],
    [1018, [32]],
    [1028, [32]],
    [1038, [32]],
    [1009, [32]],
    [1019, [32]],
    [1029, [32]],
    [1039, [32]],
    [1010, [32]],
    [1020, [32]],
    [1030, [32]],
    [1040, [32]],
    [1011, [32]],
    [1021, [32]],
    [1031, [32]],
    [1041, [32]],
    [1012, [32]],
    [1022, [32]],
    [1032, [32]],
    [1042, [32]],
    [1013, [32]],
    [1023, [32]],
    [1033, [32]],
    [1043, [32]],
    [1014, [32]],
    [1024, [32]],
    [1034, [32]],
    [1044, [32]],
    [1567, [127]],
    [1577, [127]],
    [1587, [127]],
    [1597, [127]],
    [1568, [127]],
    [1578, [127]],
    [1588, [127]],
    [1598, [127]],
    [1569, [127]],
    [1579, [127]],
    [1589, [127]],
    [1599, [127]],
    [1570, [127]],
    [1580, [127]],
    [1590, [127]],
    [1600, [127]],
    [1571, [127]],
    [1581, [127]],
    [1591, [127]],
    [1601, [127]],
    [1572, [127]],
    [1582, [127]],
    [1592, [127]],
    [1602, [127]],
    [1573, [127]],
    [1583, [127]],
    [1593, [127]],
    [1603, [127]],
    [1574, [127]],
    [1584, [127]],
    [1594, [127]],
    [1604, [127]],
    [1575, [127]],
    [1585, [127]],
    [1595, [127]],
    [1605, [127]],
    [1576, [127]],
    [1586, [127]],
    [1596, [127]],
    [1606, [127]],
    [2788, [185]],
    [2798, [185]],
    [2808, [185]],
    [2818, [185]],
    [2789, [185]],
    [2799, [185]],
    [2809, [185]],
    [2819, [185]],
    [2790, [185]],
    [2800, [185]],
    [2810, [185]],
    [2820, [185]],
    [2791, [185]],
    [2801, [185]],
    [2811, [185]],
    [2821, [185]],
    [2792, [185]],
    [2802, [185]],
    [2812, [185]],
    [2822, [185]],
    [2793, [185]],
    [2803, [185]],
    [2813, [185]],
    [2823, [185]],
    [2794, [185]],
    [2804, [185]],
    [2814, [185]],
    [2824, [185]],
    [2795, [185]],
    [2805, [185]],
    [2815, [185]],
    [2825, [185]],
    [2796, [185]],
    [2806, [185]],
    [2816, [185]],
    [2826, [185]],
    [2797, [185]],
    [2807, [185]],
    [2817, [185]],
    [2827, [185]],
    [81, [10]],
    [172, [10]],
    [756, [10]],
    [766, [10]],
    [82, [10]],
    [173, [10]],
    [757, [10]],
    [767, [10]],
    [83, [10]],
    [174, [10]],
    [758, [10]],
    [768, [10]],
    [84, [10]],
    [175, [10]],
    [759, [10]],
    [769, [10]],
    [85, [10]],
    [176, [10]],
    [760, [10]],
    [770, [10]],
    [86, [10]],
    [177, [10]],
    [761, [10]],
    [771, [10]],
    [87, [10]],
    [178, [10]],
    [762, [10]],
    [772, [10]],
    [88, [10]],
    [179, [10]],
    [763, [10]],
    [773, [10]],
    [89, [10]],
    [180, [10]],
    [764, [10]],
    [774, [10]],
    [90, [10]],
    [181, [10]],
    [765, [10]],
    [775, [10]],
    [1045, [33]],
    [1055, [33]],
    [1065, [33]],
    [1075, [33]],
    [1046, [33]],
    [1056, [33]],
    [1066, [33]],
    [1076, [33]],
    [1047, [33]],
    [1057, [33]],
    [1067, [33]],
    [1077, [33]],
    [1048, [33]],
    [1058, [33]],
    [1068, [33]],
    [1078, [33]],
    [1049, [33]],
    [1059, [33]],
    [1069, [33]],
    [1079, [33]],
    [1050, [33]],
    [1060, [33]],
    [1070, [33]],
    [1080, [33]],
    [1051, [33]],
    [1061, [33]],
    [1071, [33]],
    [1081, [33]],
    [1052, [33]],
    [1062, [33]],
    [1072, [33]],
    [1082, [33]],
    [1053, [33]],
    [1063, [33]],
    [1073, [33]],
    [1083, [33]],
    [1054, [33]],
    [1064, [33]],
    [1074, [33]],
    [1084, [33]],
    [1607, [128]],
    [1617, [128]],
    [1627, [128]],
    [1637, [128]],
    [1608, [128]],
    [1618, [128]],
    [1628, [128]],
    [1638, [128]],
    [1609, [128]],
    [1619, [128]],
    [1629, [128]],
    [1639, [128]],
    [1610, [128]],
    [1620, [128]],
    [1630, [128]],
    [1640, [128]],
    [1611, [128]],
    [1621, [128]],
    [1631, [128]],
    [1641, [128]],
    [1612, [128]],
    [1622, [128]],
    [1632, [128]],
    [1642, [128]],
    [1613, [128]],
    [1623, [128]],
    [1633, [128]],
    [1643, [128]],
    [1614, [128]],
    [1624, [128]],
    [1634, [128]],
    [1644, [128]],
    [1615, [128]],
    [1625, [128]],
    [1635, [128]],
    [1645, [128]],
    [1616, [128]],
    [1626, [128]],
    [1636, [128]],
    [1646, [128]],
    [91, [11]],
    [182, [11]],
    [776, [11]],
    [786, [11]],
    [92, [11]],
    [183, [11]],
    [777, [11]],
    [787, [11]],
    [93, [11]],
    [184, [11]],
    [778, [11]],
    [788, [11]],
    [94, [11]],
    [185, [11]],
    [779, [11]],
    [789, [11]],
    [95, [11]],
    [186, [11]],
    [780, [11]],
    [790, [11]],
    [96, [11]],
    [187, [11]],
    [781, [11]],
    [791, [11]],
    [97, [11]],
    [188, [11]],
    [782, [11]],
    [792, [11]],
    [98, [11]],
    [189, [11]],
    [783, [11]],
    [793, [11]],
    [99, [11]],
    [190, [11]],
    [784, [11]],
    [794, [11]],
    [100, [11]],
    [191, [11]],
    [785, [11]],
    [795, [11]],
    [1085, [106]],
    [1095, [106]],
    [1105, [106]],
    [1115, [106]],
    [1086, [106]],
    [1096, [106]],
    [1106, [106]],
    [1116, [106]],
    [1087, [106]],
    [1097, [106]],
    [1107, [106]],
    [1117, [106]],
    [1088, [106]],
    [1098, [106]],
    [1108, [106]],
    [1118, [106]],
    [1089, [106]],
    [1099, [106]],
    [1109, [106]],
    [1119, [106]],
    [1090, [106]],
    [1100, [106]],
    [1110, [106]],
    [1120, [106]],
    [1091, [106]],
    [1101, [106]],
    [1111, [106]],
    [1121, [106]],
    [1092, [106]],
    [1102, [106]],
    [1112, [106]],
    [1122, [106]],
    [1093, [106]],
    [1103, [106]],
    [1113, [106]],
    [1123, [106]],
    [1094, [106]],
    [1104, [106]],
    [1114, [106]],
    [1124, [106]],
    [1647, [129]],
    [1657, [129]],
    [1667, [129]],
    [1677, [129]],
    [1648, [129]],
    [1658, [129]],
    [1668, [129]],
    [1678, [129]],
    [1649, [129]],
    [1659, [129]],
    [1669, [129]],
    [1679, [129]],
    [1650, [129]],
    [1660, [129]],
    [1670, [129]],
    [1680, [129]],
    [1651, [129]],
    [1661, [129]],
    [1671, [129]],
    [1681, [129]],
    [1652, [129]],
    [1662, [129]],
    [1672, [129]],
    [1682, [129]],
    [1653, [129]],
    [1663, [129]],
    [1673, [129]],
    [1683, [129]],
    [1654, [129]],
    [1664, [129]],
    [1674, [129]],
    [1684, [129]],
    [1655, [129]],
    [1665, [129]],
    [1675, [129]],
    [1685, [129]],
    [1656, [129]],
    [1666, [129]],
    [1676, [129]],
    [1686, [129]],
    [2828, [186]],
    [2838, [186]],
    [2848, [186]],
    [2858, [186]],
    [2829, [186]],
    [2839, [186]],
    [2849, [186]],
    [2859, [186]],
    [2830, [186]],
    [2840, [186]],
    [2850, [186]],
    [2860, [186]],
    [2831, [186]],
    [2841, [186]],
    [2851, [186]],
    [2861, [186]],
    [2832, [186]],
    [2842, [186]],
    [2852, [186]],
    [2862, [186]],
    [2833, [186]],
    [2843, [186]],
    [2853, [186]],
    [2863, [186]],
    [2834, [186]],
    [2844, [186]],
    [2854, [186]],
    [2864, [186]],
    [2835, [186]],
    [2845, [186]],
    [2855, [186]],
    [2865, [186]],
    [2836, [186]],
    [2846, [186]],
    [2856, [186]],
    [2866, [186]],
    [2837, [186]],
    [2847, [186]],
    [2857, [186]],
    [2867, [186]],
    [442, [66]],
    [452, [66]],
    [796, [66]],
    [806, [66]],
    [443, [66]],
    [453, [66]],
    [797, [66]],
    [807, [66]],
    [444, [66]],
    [454, [66]],
    [798, [66]],
    [808, [66]],
    [445, [66]],
    [455, [66]],
    [799, [66]],
    [809, [66]],
    [446, [66]],
    [456, [66]],
    [800, [66]],
    [810, [66]],
    [447, [66]],
    [457, [66]],
    [801, [66]],
    [811, [66]],
    [448, [66]],
    [458, [66]],
    [802, [66]],
    [812, [66]],
    [449, [66]],
    [459, [66]],
    [803, [66]],
    [813, [66]],
    [450, [66]],
    [460, [66]],
    [804, [66]],
    [814, [66]],
    [451, [66]],
    [461, [66]],
    [805, [66]],
    [815, [66]],
    [1125, [107]],
    [1135, [107]],
    [1145, [107]],
    [1155, [107]],
    [1126, [107]],
    [1136, [107]],
    [1146, [107]],
    [1156, [107]],
    [1127, [107]],
    [1137, [107]],
    [1147, [107]],
    [1157, [107]],
    [1128, [107]],
    [1138, [107]],
    [1148, [107]],
    [1158, [107]],
    [1129, [107]],
    [1139, [107]],
    [1149, [107]],
    [1159, [107]],
    [1130, [107]],
    [1140, [107]],
    [1150, [107]],
    [1160, [107]],
    [1131, [107]],
    [1141, [107]],
    [1151, [107]],
    [1161, [107]],
    [1132, [107]],
    [1142, [107]],
    [1152, [107]],
    [1162, [107]],
    [1133, [107]],
    [1143, [107]],
    [1153, [107]],
    [1163, [107]],
    [1134, [107]],
    [1144, [107]],
    [1154, [107]],
    [1164, [107]],
    [2083, [153]],
    [2093, [153]],
    [2103, [153]],
    [2113, [153]],
    [2084, [153]],
    [2094, [153]],
    [2104, [153]],
    [2114, [153]],
    [2085, [153]],
    [2095, [153]],
    [2105, [153]],
    [2115, [153]],
    [2086, [153]],
    [2096, [153]],
    [2106, [153]],
    [2116, [153]],
    [2087, [153]],
    [2097, [153]],
    [2107, [153]],
    [2117, [153]],
    [2088, [153]],
    [2098, [153]],
    [2108, [153]],
    [2118, [153]],
    [2089, [153]],
    [2099, [153]],
    [2109, [153]],
    [2119, [153]],
    [2090, [153]],
    [2100, [153]],
    [2110, [153]],
    [2120, [153]],
    [2091, [153]],
    [2101, [153]],
    [2111, [153]],
    [2121, [153]],
    [2092, [153]],
    [2102, [153]],
    [2112, [153]],
    [2122, [153]],
    [462, [67]],
    [472, [67]],
    [816, [67]],
    [826, [67]],
    [463, [67]],
    [473, [67]],
    [817, [67]],
    [827, [67]],
    [464, [67]],
    [474, [67]],
    [818, [67]],
    [828, [67]],
    [465, [67]],
    [475, [67]],
    [819, [67]],
    [829, [67]],
    [466, [67]],
    [476, [67]],
    [820, [67]],
    [830, [67]],
    [467, [67]],
    [477, [67]],
    [821, [67]],
    [831, [67]],
    [468, [67]],
    [478, [67]],
    [822, [67]],
    [832, [67]],
    [469, [67]],
    [479, [67]],
    [823, [67]],
    [833, [67]],
    [470, [67]],
    [480, [67]],
    [824, [67]],
    [834, [67]],
    [471, [67]],
    [481, [67]],
    [825, [67]],
    [835, [67]],
    [1165, [108]],
    [1175, [108]],
    [1185, [108]],
    [1195, [108]],
    [1166, [108]],
    [1176, [108]],
    [1186, [108]],
    [1196, [108]],
    [1167, [108]],
    [1177, [108]],
    [1187, [108]],
    [1197, [108]],
    [1168, [108]],
    [1178, [108]],
    [1188, [108]],
    [1198, [108]],
    [1169, [108]],
    [1179, [108]],
    [1189, [108]],
    [1199, [108]],
    [1170, [108]],
    [1180, [108]],
    [1190, [108]],
    [1200, [108]],
    [1171, [108]],
    [1181, [108]],
    [1191, [108]],
    [1201, [108]],
    [1172, [108]],
    [1182, [108]],
    [1192, [108]],
    [1202, [108]],
    [1173, [108]],
    [1183, [108]],
    [1193, [108]],
    [1203, [108]],
    [1174, [108]],
    [1184, [108]],
    [1194, [108]],
    [1204, [108]],
    [2123, [154]],
    [2133, [154]],
    [2143, [154]],
    [2153, [154]],
    [2124, [154]],
    [2134, [154]],
    [2144, [154]],
    [2154, [154]],
    [2125, [154]],
    [2135, [154]],
    [2145, [154]],
    [2155, [154]],
    [2126, [154]],
    [2136, [154]],
    [2146, [154]],
    [2156, [154]],
    [2127, [154]],
    [2137, [154]],
    [2147, [154]],
    [2157, [154]],
    [2128, [154]],
    [2138, [154]],
    [2148, [154]],
    [2158, [154]],
    [2129, [154]],
    [2139, [154]],
    [2149, [154]],
    [2159, [154]],
    [2130, [154]],
    [2140, [154]],
    [2150, [154]],
    [2160, [154]],
    [2131, [154]],
    [2141, [154]],
    [2151, [154]],
    [2161, [154]],
    [2132, [154]],
    [2142, [154]],
    [2152, [154]],
    [2162, [154]],
    [111, [13]],
    [192, [13]],
    [856, [13]],
    [866, [13]],
    [112, [13]],
    [193, [13]],
    [857, [13]],
    [867, [13]],
    [113, [13]],
    [194, [13]],
    [858, [13]],
    [868, [13]],
    [114, [13]],
    [195, [13]],
    [859, [13]],
    [869, [13]],
    [115, [13]],
    [196, [13]],
    [860, [13]],
    [870, [13]],
    [116, [13]],
    [197, [13]],
    [861, [13]],
    [871, [13]],
    [117, [13]],
    [198, [13]],
    [862, [13]],
    [872, [13]],
    [118, [13]],
    [199, [13]],
    [863, [13]],
    [873, [13]],
    [119, [13]],
    [200, [13]],
    [864, [13]],
    [874, [13]],
    [120, [13]],
    [201, [13]],
    [865, [13]],
    [875, [13]],
    [2868, [13]],
    [2871, [13]],
    [2874, [13]],
    [2877, [13]],
    [2869, [13]],
    [2872, [13]],
    [2875, [13]],
    [2878, [13]],
    [2870, [13]],
    [2873, [13]],
    [2876, [13]],
    [2879, [13]],
    [542, [159]],
    [552, [159]],
    [562, [159]],
    [572, [159]],
    [543, [159]],
    [553, [159]],
    [563, [159]],
    [573, [159]],
    [544, [159]],
    [554, [159]],
    [564, [159]],
    [574, [159]],
    [545, [159]],
    [555, [159]],
    [565, [159]],
    [575, [159]],
    [546, [159]],
    [556, [159]],
    [566, [159]],
    [576, [159]],
    [547, [159]],
    [557, [159]],
    [567, [159]],
    [577, [159]],
    [548, [159]],
    [558, [159]],
    [568, [159]],
    [578, [159]],
    [549, [159]],
    [559, [159]],
    [569, [159]],
    [579, [159]],
    [550, [159]],
    [560, [159]],
    [570, [159]],
    [580, [159]],
    [551, [159]],
    [561, [159]],
    [571, [159]],
    [581, [159]],
    [2880, [159]],
    [2883, [159]],
    [2886, [159]],
    [2889, [159]],
    [2881, [159]],
    [2884, [159]],
    [2887, [159]],
    [2890, [159]],
    [2882, [159]],
    [2885, [159]],
    [2888, [159]],
    [2891, [159]],
    [2966, [194]],
    [2979, [194]],
    [2992, [194]],
    [3005, [194]],
    [2967, [194]],
    [2980, [194]],
    [2993, [194]],
    [3006, [194]],
    [2968, [194]],
    [2981, [194]],
    [2994, [194]],
    [3007, [194]],
    [2969, [194]],
    [2982, [194]],
    [2995, [194]],
    [3008, [194]],
    [2970, [194]],
    [2983, [194]],
    [2996, [194]],
    [3009, [194]],
    [2971, [194]],
    [2984, [194]],
    [2997, [194]],
    [3010, [194]],
    [2972, [194]],
    [2985, [194]],
    [2998, [194]],
    [3011, [194]],
    [2973, [194]],
    [2986, [194]],
    [2999, [194]],
    [3012, [194]],
    [2974, [194]],
    [2987, [194]],
    [3000, [194]],
    [3013, [194]],
    [2975, [194]],
    [2988, [194]],
    [3001, [194]],
    [3014, [194]],
    [2976, [194]],
    [2989, [194]],
    [3002, [194]],
    [3015, [194]],
    [2977, [194]],
    [2990, [194]],
    [3003, [194]],
    [3016, [194]],
    [2978, [194]],
    [2991, [194]],
    [3004, [194]],
    [3017, [194]],
    [121, [14]],
    [202, [14]],
    [876, [14]],
    [886, [14]],
    [122, [14]],
    [203, [14]],
    [877, [14]],
    [887, [14]],
    [123, [14]],
    [204, [14]],
    [878, [14]],
    [888, [14]],
    [124, [14]],
    [205, [14]],
    [879, [14]],
    [889, [14]],
    [125, [14]],
    [206, [14]],
    [880, [14]],
    [890, [14]],
    [126, [14]],
    [207, [14]],
    [881, [14]],
    [891, [14]],
    [127, [14]],
    [208, [14]],
    [882, [14]],
    [892, [14]],
    [128, [14]],
    [209, [14]],
    [883, [14]],
    [893, [14]],
    [129, [14]],
    [210, [14]],
    [884, [14]],
    [894, [14]],
    [130, [14]],
    [211, [14]],
    [885, [14]],
    [895, [14]],
    [2892, [14]],
    [2895, [14]],
    [2898, [14]],
    [2901, [14]],
    [2893, [14]],
    [2896, [14]],
    [2899, [14]],
    [2902, [14]],
    [2894, [14]],
    [2897, [14]],
    [2900, [14]],
    [2903, [14]],
    [392, [68]],
    [402, [68]],
    [432, [68]],
    [482, [68]],
    [393, [68]],
    [403, [68]],
    [433, [68]],
    [483, [68]],
    [394, [68]],
    [404, [68]],
    [434, [68]],
    [484, [68]],
    [395, [68]],
    [405, [68]],
    [435, [68]],
    [485, [68]],
    [396, [68]],
    [406, [68]],
    [436, [68]],
    [486, [68]],
    [397, [68]],
    [407, [68]],
    [437, [68]],
    [487, [68]],
    [398, [68]],
    [408, [68]],
    [438, [68]],
    [488, [68]],
    [399, [68]],
    [409, [68]],
    [439, [68]],
    [489, [68]],
    [400, [68]],
    [410, [68]],
    [440, [68]],
    [490, [68]],
    [401, [68]],
    [411, [68]],
    [441, [68]],
    [491, [68]],
    [2904, [68]],
    [2907, [68]],
    [2910, [68]],
    [2913, [68]],
    [2905, [68]],
    [2908, [68]],
    [2911, [68]],
    [2914, [68]],
    [2906, [68]],
    [2909, [68]],
    [2912, [68]],
    [2915, [68]],
    [3018, [195]],
    [3031, [195]],
    [3044, [195]],
    [3057, [195]],
    [3019, [195]],
    [3032, [195]],
    [3045, [195]],
    [3058, [195]],
    [3020, [195]],
    [3033, [195]],
    [3046, [195]],
    [3059, [195]],
    [3021, [195]],
    [3034, [195]],
    [3047, [195]],
    [3060, [195]],
    [3022, [195]],
    [3035, [195]],
    [3048, [195]],
    [3061, [195]],
    [3023, [195]],
    [3036, [195]],
    [3049, [195]],
    [3062, [195]],
    [3024, [195]],
    [3037, [195]],
    [3050, [195]],
    [3063, [195]],
    [3025, [195]],
    [3038, [195]],
    [3051, [195]],
    [3064, [195]],
    [3026, [195]],
    [3039, [195]],
    [3052, [195]],
    [3065, [195]],
    [3027, [195]],
    [3040, [195]],
    [3053, [195]],
    [3066, [195]],
    [3028, [195]],
    [3041, [195]],
    [3054, [195]],
    [3067, [195]],
    [3029, [195]],
    [3042, [195]],
    [3055, [195]],
    [3068, [195]],
    [3030, [195]],
    [3043, [195]],
    [3056, [195]],
    [3069, [195]],
    [502, [69]],
    [512, [69]],
    [896, [69]],
    [906, [69]],
    [503, [69]],
    [513, [69]],
    [897, [69]],
    [907, [69]],
    [504, [69]],
    [514, [69]],
    [898, [69]],
    [908, [69]],
    [505, [69]],
    [515, [69]],
    [899, [69]],
    [909, [69]],
    [506, [69]],
    [516, [69]],
    [900, [69]],
    [910, [69]],
    [507, [69]],
    [517, [69]],
    [901, [69]],
    [911, [69]],
    [508, [69]],
    [518, [69]],
    [902, [69]],
    [912, [69]],
    [509, [69]],
    [519, [69]],
    [903, [69]],
    [913, [69]],
    [510, [69]],
    [520, [69]],
    [904, [69]],
    [914, [69]],
    [511, [69]],
    [521, [69]],
    [905, [69]],
    [915, [69]],
    [2916, [69]],
    [2919, [69]],
    [2949, [69]],
    [2922, [69]],
    [2917, [69]],
    [2920, [69]],
    [2950, [69]],
    [2923, [69]],
    [2918, [69]],
    [2921, [69]],
    [2951, [69]],
    [2924, [69]],
    [492, [163]],
    [716, [163]],
    [726, [163]],
    [836, [163]],
    [493, [163]],
    [717, [163]],
    [727, [163]],
    [837, [163]],
    [494, [163]],
    [718, [163]],
    [728, [163]],
    [838, [163]],
    [495, [163]],
    [719, [163]],
    [729, [163]],
    [839, [163]],
    [496, [163]],
    [720, [163]],
    [730, [163]],
    [840, [163]],
    [497, [163]],
    [721, [163]],
    [731, [163]],
    [841, [163]],
    [498, [163]],
    [722, [163]],
    [732, [163]],
    [842, [163]],
    [499, [163]],
    [723, [163]],
    [733, [163]],
    [843, [163]],
    [500, [163]],
    [724, [163]],
    [734, [163]],
    [844, [163]],
    [501, [163]],
    [725, [163]],
    [735, [163]],
    [845, [163]],
    [2925, [163]],
    [2928, [163]],
    [2931, [163]],
    [2934, [163]],
    [2926, [163]],
    [2929, [163]],
    [2932, [163]],
    [2935, [163]],
    [2927, [163]],
    [2930, [163]],
    [2933, [163]],
    [2936, [163]],
    [6936, [196]],
    [6949, [196]],
    [6962, [196]],
    [6975, [196]],
    [6937, [196]],
    [6950, [196]],
    [6963, [196]],
    [6976, [196]],
    [6938, [196]],
    [6951, [196]],
    [6964, [196]],
    [6977, [196]],
    [6939, [196]],
    [6952, [196]],
    [6965, [196]],
    [6978, [196]],
    [6940, [196]],
    [6953, [196]],
    [6966, [196]],
    [6979, [196]],
    [6941, [196]],
    [6954, [196]],
    [6967, [196]],
    [6980, [196]],
    [6942, [196]],
    [6955, [196]],
    [6968, [196]],
    [6981, [196]],
    [6943, [196]],
    [6956, [196]],
    [6969, [196]],
    [6982, [196]],
    [6944, [196]],
    [6957, [196]],
    [6970, [196]],
    [6983, [196]],
    [6945, [196]],
    [6958, [196]],
    [6971, [196]],
    [6984, [196]],
    [6946, [196]],
    [6959, [196]],
    [6972, [196]],
    [6985, [196]],
    [6947, [196]],
    [6960, [196]],
    [6973, [196]],
    [6986, [196]],
    [6948, [196]],
    [6961, [196]],
    [6974, [196]],
    [6987, [196]],
    [522, [70]],
    [532, [70]],
    [916, [70]],
    [926, [70]],
    [523, [70]],
    [533, [70]],
    [917, [70]],
    [927, [70]],
    [524, [70]],
    [534, [70]],
    [918, [70]],
    [928, [70]],
    [525, [70]],
    [535, [70]],
    [919, [70]],
    [929, [70]],
    [526, [70]],
    [536, [70]],
    [920, [70]],
    [930, [70]],
    [527, [70]],
    [537, [70]],
    [921, [70]],
    [931, [70]],
    [528, [70]],
    [538, [70]],
    [922, [70]],
    [932, [70]],
    [529, [70]],
    [539, [70]],
    [923, [70]],
    [933, [70]],
    [530, [70]],
    [540, [70]],
    [924, [70]],
    [934, [70]],
    [531, [70]],
    [541, [70]],
    [925, [70]],
    [935, [70]],
    [2937, [70]],
    [2940, [70]],
    [2943, [70]],
    [2946, [70]],
    [2938, [70]],
    [2941, [70]],
    [2944, [70]],
    [2947, [70]],
    [2939, [70]],
    [2942, [70]],
    [2945, [70]],
    [2948, [70]],
    [6988, [197]],
    [7001, [197]],
    [7014, [197]],
    [7027, [197]],
    [6989, [197]],
    [7002, [197]],
    [7015, [197]],
    [7028, [197]],
    [6990, [197]],
    [7003, [197]],
    [7016, [197]],
    [7029, [197]],
    [6991, [197]],
    [7004, [197]],
    [7017, [197]],
    [7030, [197]],
    [6992, [197]],
    [7005, [197]],
    [7018, [197]],
    [7031, [197]],
    [6993, [197]],
    [7006, [197]],
    [7019, [197]],
    [7032, [197]],
    [6994, [197]],
    [7007, [197]],
    [7020, [197]],
    [7033, [197]],
    [6995, [197]],
    [7008, [197]],
    [7021, [197]],
    [7034, [197]],
    [6996, [197]],
    [7009, [197]],
    [7022, [197]],
    [7035, [197]],
    [6997, [197]],
    [7010, [197]],
    [7023, [197]],
    [7036, [197]],
    [6998, [197]],
    [7011, [197]],
    [7024, [197]],
    [7037, [197]],
    [6999, [197]],
    [7012, [197]],
    [7025, [197]],
    [7038, [197]],
    [7000, [197]],
    [7013, [197]],
    [7026, [197]],
    [7039, [197]],
    [41, [8]],
    [51, [8]],
    [61, [8]],
    [412, [8]],
    [422, [8]],
    [3770, [8]],
    [42, [8]],
    [52, [8]],
    [62, [8]],
    [413, [8]],
    [423, [8]],
    [3771, [8]],
    [43, [8]],
    [53, [8]],
    [63, [8]],
    [414, [8]],
    [424, [8]],
    [3772, [8]],
    [44, [8]],
    [54, [8]],
    [64, [8]],
    [415, [8]],
    [425, [8]],
    [3773, [8]],
    [45, [8]],
    [55, [8]],
    [65, [8]],
    [416, [8]],
    [426, [8]],
    [3774, [8]],
    [46, [8]],
    [56, [8]],
    [66, [8]],
    [417, [8]],
    [427, [8]],
    [3775, [8]],
    [47, [8]],
    [57, [8]],
    [67, [8]],
    [418, [8]],
    [428, [8]],
    [3776, [8]],
    [48, [8]],
    [58, [8]],
    [68, [8]],
    [419, [8]],
    [429, [8]],
    [3777, [8]],
    [49, [8]],
    [59, [8]],
    [69, [8]],
    [420, [8]],
    [430, [8]],
    [3778, [8]],
    [50, [8]],
    [60, [8]],
    [70, [8]],
    [421, [8]],
    [431, [8]],
    [3779, [8]],
    [6916, [8]],
    [6917, [8]],
    [6918, [8]],
    [6919, [8]],
    [6920, [8]],
    [6921, [8]],
    [6931, [8]],
    [6929, [8]],
    [6928, [8]],
    [6927, [8]],
    [6930, [8]],
    [6926, [8]],
    [101, [12]],
    [102, [12]],
    [103, [12]],
    [104, [12]],
    [105, [12]],
    [106, [12]],
    [107, [12]],
    [108, [12]],
    [109, [12]],
    [110, [12]],
    [131, [15]],
    [132, [15]],
    [133, [15]],
    [134, [15]],
    [135, [15]],
    [136, [15]],
    [137, [15]],
    [138, [15]],
    [139, [15]],
    [140, [15]],
    [2205, [155]],
    [2212, [155]],
    [2233, [155]],
    [2240, [155]],
    [2163, [155]],
    [2170, [155]],
    [2219, [155]],
    [2226, [155]],
    [2191, [155]],
    [2198, [155]],
    [2247, [155]],
    [2254, [155]],
    [2177, [155]],
    [2184, [155]],
    [2206, [155]],
    [2213, [155]],
    [2234, [155]],
    [2241, [155]],
    [2164, [155]],
    [2171, [155]],
    [2220, [155]],
    [2227, [155]],
    [2192, [155]],
    [2199, [155]],
    [2248, [155]],
    [2255, [155]],
    [2178, [155]],
    [2185, [155]],
    [2207, [155]],
    [2214, [155]],
    [2235, [155]],
    [2242, [155]],
    [2165, [155]],
    [2172, [155]],
    [2221, [155]],
    [2228, [155]],
    [2193, [155]],
    [2200, [155]],
    [2249, [155]],
    [2256, [155]],
    [2179, [155]],
    [2186, [155]],
    [2208, [155]],
    [2215, [155]],
    [2236, [155]],
    [2243, [155]],
    [2166, [155]],
    [2173, [155]],
    [2222, [155]],
    [2229, [155]],
    [2194, [155]],
    [2201, [155]],
    [2250, [155]],
    [2257, [155]],
    [2180, [155]],
    [2187, [155]],
    [2209, [155]],
    [2216, [155]],
    [2237, [155]],
    [2244, [155]],
    [2167, [155]],
    [2174, [155]],
    [2223, [155]],
    [2230, [155]],
    [2195, [155]],
    [2202, [155]],
    [2251, [155]],
    [2258, [155]],
    [2181, [155]],
    [2188, [155]],
    [2210, [155]],
    [2217, [155]],
    [2238, [155]],
    [2245, [155]],
    [2168, [155]],
    [2175, [155]],
    [2224, [155]],
    [2231, [155]],
    [2196, [155]],
    [2203, [155]],
    [2252, [155]],
    [2259, [155]],
    [2182, [155]],
    [2189, [155]],
    [2211, [155]],
    [2218, [155]],
    [2239, [155]],
    [2246, [155]],
    [2169, [155]],
    [2176, [155]],
    [2225, [155]],
    [2232, [155]],
    [2197, [155]],
    [2204, [155]],
    [2253, [155]],
    [2260, [155]],
    [2183, [155]],
    [2190, [155]],
    [2261, [156]],
    [2271, [156]],
    [2281, [156]],
    [2291, [156]],
    [2301, [156]],
    [2311, [156]],
    [2321, [156]],
    [2262, [156]],
    [2272, [156]],
    [2282, [156]],
    [2292, [156]],
    [2302, [156]],
    [2312, [156]],
    [2322, [156]],
    [2263, [156]],
    [2273, [156]],
    [2283, [156]],
    [2293, [156]],
    [2303, [156]],
    [2313, [156]],
    [2323, [156]],
    [2264, [156]],
    [2274, [156]],
    [2284, [156]],
    [2294, [156]],
    [2304, [156]],
    [2314, [156]],
    [2324, [156]],
    [2265, [156]],
    [2275, [156]],
    [2285, [156]],
    [2295, [156]],
    [2305, [156]],
    [2315, [156]],
    [2325, [156]],
    [2266, [156]],
    [2276, [156]],
    [2286, [156]],
    [2296, [156]],
    [2306, [156]],
    [2316, [156]],
    [2326, [156]],
    [2267, [156]],
    [2277, [156]],
    [2287, [156]],
    [2297, [156]],
    [2307, [156]],
    [2317, [156]],
    [2327, [156]],
    [2298, [156]],
    [2308, [156]],
    [2318, [156]],
    [2288, [156]],
    [2328, [156]],
    [2268, [156]],
    [2278, [156]],
    [3829, [156]],
    [2299, [156]],
    [2309, [156]],
    [2319, [156]],
    [2289, [156]],
    [2329, [156]],
    [2269, [156]],
    [2279, [156]],
    [3830, [156]],
    [2300, [156]],
    [2310, [156]],
    [2320, [156]],
    [2290, [156]],
    [2330, [156]],
    [2270, [156]],
    [2280, [156]],
    [3831, [156]],
    [3837, [156]],
    [3839, [156]],
    [3841, [156]],
    [3843, [156]],
    [3845, [156]],
    [3847, [156]],
    [3849, [156]],
    [3832, [156]],
    [3834, [156]],
    [3838, [156]],
    [3840, [156]],
    [3842, [156]],
    [3844, [156]],
    [3846, [156]],
    [3848, [156]],
    [3850, [156]],
    [3833, [156]],
    [3835, [156]],
    [3836, [156]],
    [2952, [187]],
    [2959, [187]],
    [2953, [187]],
    [2960, [187]],
    [2954, [187]],
    [2961, [187]],
    [2955, [187]],
    [2962, [187]],
    [2956, [187]],
    [2963, [187]],
    [2957, [187]],
    [2964, [187]],
    [2958, [187]],
    [2965, [187]],
    [3780, [203]],
    [3790, [203]],
    [3800, [203]],
    [3810, [203]],
    [3781, [203]],
    [3791, [203]],
    [3801, [203]],
    [3811, [203]],
    [3782, [203]],
    [3792, [203]],
    [3802, [203]],
    [3812, [203]],
    [3783, [203]],
    [3793, [203]],
    [3803, [203]],
    [3813, [203]],
    [3784, [203]],
    [3794, [203]],
    [3804, [203]],
    [3814, [203]],
    [3785, [203]],
    [3795, [203]],
    [3805, [203]],
    [3815, [203]],
    [3786, [203]],
    [3796, [203]],
    [3806, [203]],
    [3816, [203]],
    [3787, [203]],
    [3797, [203]],
    [3807, [203]],
    [3817, [203]],
    [3788, [203]],
    [3798, [203]],
    [3808, [203]],
    [3818, [203]],
    [3789, [203]],
    [3799, [203]],
    [3809, [203]],
    [3819, [203]],
    [1477, [122]],
    [1478, [122]],
    [1493, [122]],
    [1479, [122]],
    [1494, [122]],
    [1509, [122]],
    [1480, [122]],
    [1495, [122]],
    [1510, [122]],
    [1525, [122]],
    [1481, [122]],
    [1496, [122]],
    [1511, [122]],
    [1526, [122]],
    [1482, [122]],
    [1497, [122]],
    [1512, [122]],
    [1527, [122]],
    [1542, [122]],
    [1483, [122]],
    [1498, [122]],
    [1513, [122]],
    [1528, [122]],
    [1543, [122]],
    [1558, [122]],
    [1484, [122]],
    [1499, [122]],
    [1514, [122]],
    [1529, [122]],
    [1544, [122]],
    [1559, [122]],
    [1485, [122]],
    [1500, [122]],
    [1515, [122]],
    [1530, [122]],
    [1545, [122]],
    [1560, [122]],
    [1486, [122]],
    [1501, [122]],
    [1516, [122]],
    [1531, [122]],
    [1546, [122]],
    [1561, [122]],
    [1487, [122]],
    [1502, [122]],
    [1517, [122]],
    [1532, [122]],
    [1547, [122]],
    [1562, [122]],
    [1488, [122]],
    [1503, [122]],
    [1518, [122]],
    [1533, [122]],
    [1548, [122]],
    [1563, [122]],
    [1489, [122]],
    [1504, [122]],
    [1519, [122]],
    [1534, [122]],
    [1549, [122]],
    [1564, [122]],
    [1490, [122]],
    [1505, [122]],
    [1520, [122]],
    [1535, [122]],
    [1550, [122]],
    [1565, [122]],
    [1491, [122]],
    [1506, [122]],
    [1521, [122]],
    [1536, [122]],
    [1551, [122]],
    [1566, [122]],
    [1207, [112]],
    [1687, [112]],
    [1205, [112]],
    [1206, [112]],
    [937, [112]],
    [1208, [112]],
    [1688, [112]],
    [1218, [112]],
    [1697, [112]],
    [1209, [112]],
    [1689, [112]],
    [1219, [112]],
    [1698, [112]],
    [1229, [112]],
    [1706, [112]],
    [1210, [112]],
    [1690, [112]],
    [1220, [112]],
    [1699, [112]],
    [1230, [112]],
    [1707, [112]],
    [1211, [112]],
    [1691, [112]],
    [1221, [112]],
    [1700, [112]],
    [1231, [112]],
    [1708, [112]],
    [1212, [112]],
    [1692, [112]],
    [1222, [112]],
    [1701, [112]],
    [1232, [112]],
    [1709, [112]],
    [1213, [112]],
    [1693, [112]],
    [1223, [112]],
    [1702, [112]],
    [1233, [112]],
    [1710, [112]],
    [1214, [112]],
    [1694, [112]],
    [1224, [112]],
    [1703, [112]],
    [1234, [112]],
    [1711, [112]],
    [1215, [112]],
    [1695, [112]],
    [1225, [112]],
    [1704, [112]],
    [1235, [112]],
    [1712, [112]],
    [1216, [112]],
    [1696, [112]],
    [1226, [112]],
    [1705, [112]],
    [1236, [112]],
    [1713, [112]],
    [1277, [114]],
    [1287, [114]],
    [1297, [114]],
    [1307, [114]],
    [1278, [114]],
    [1288, [114]],
    [1298, [114]],
    [1308, [114]],
    [1279, [114]],
    [1289, [114]],
    [1299, [114]],
    [1309, [114]],
    [1280, [114]],
    [1290, [114]],
    [1300, [114]],
    [1310, [114]],
    [1281, [114]],
    [1291, [114]],
    [1301, [114]],
    [1311, [114]],
    [1282, [114]],
    [1292, [114]],
    [1302, [114]],
    [1312, [114]],
    [1283, [114]],
    [1293, [114]],
    [1303, [114]],
    [1313, [114]],
    [1284, [114]],
    [1294, [114]],
    [1304, [114]],
    [1314, [114]],
    [1285, [114]],
    [1295, [114]],
    [1305, [114]],
    [1315, [114]],
    [1286, [114]],
    [1296, [114]],
    [1306, [114]],
    [1316, [114]],
    [1317, [115]],
    [1327, [115]],
    [1337, [115]],
    [1347, [115]],
    [1318, [115]],
    [1328, [115]],
    [1338, [115]],
    [1348, [115]],
    [1319, [115]],
    [1329, [115]],
    [1339, [115]],
    [1349, [115]],
    [1320, [115]],
    [1330, [115]],
    [1340, [115]],
    [1350, [115]],
    [1321, [115]],
    [1331, [115]],
    [1341, [115]],
    [1351, [115]],
    [1322, [115]],
    [1332, [115]],
    [1342, [115]],
    [1352, [115]],
    [1323, [115]],
    [1333, [115]],
    [1343, [115]],
    [1353, [115]],
    [1324, [115]],
    [1334, [115]],
    [1344, [115]],
    [1354, [115]],
    [1325, [115]],
    [1335, [115]],
    [1345, [115]],
    [1355, [115]],
    [1326, [115]],
    [1336, [115]],
    [1346, [115]],
    [1356, [115]],
    [1357, [116]],
    [1367, [116]],
    [1377, [116]],
    [1387, [116]],
    [1358, [116]],
    [1368, [116]],
    [1378, [116]],
    [1388, [116]],
    [1359, [116]],
    [1369, [116]],
    [1379, [116]],
    [1389, [116]],
    [1360, [116]],
    [1370, [116]],
    [1380, [116]],
    [1390, [116]],
    [1361, [116]],
    [1371, [116]],
    [1381, [116]],
    [1391, [116]],
    [1362, [116]],
    [1372, [116]],
    [1382, [116]],
    [1392, [116]],
    [1363, [116]],
    [1373, [116]],
    [1383, [116]],
    [1393, [116]],
    [1364, [116]],
    [1374, [116]],
    [1384, [116]],
    [1394, [116]],
    [1365, [116]],
    [1375, [116]],
    [1385, [116]],
    [1395, [116]],
    [1366, [116]],
    [1376, [116]],
    [1386, [116]],
    [1396, [116]],
    [1397, [117]],
    [1407, [117]],
    [1417, [117]],
    [1427, [117]],
    [1398, [117]],
    [1408, [117]],
    [1418, [117]],
    [1428, [117]],
    [1399, [117]],
    [1409, [117]],
    [1419, [117]],
    [1429, [117]],
    [1400, [117]],
    [1410, [117]],
    [1420, [117]],
    [1430, [117]],
    [1401, [117]],
    [1411, [117]],
    [1421, [117]],
    [1431, [117]],
    [1402, [117]],
    [1412, [117]],
    [1422, [117]],
    [1432, [117]],
    [1403, [117]],
    [1413, [117]],
    [1423, [117]],
    [1433, [117]],
    [1404, [117]],
    [1414, [117]],
    [1424, [117]],
    [1434, [117]],
    [1405, [117]],
    [1415, [117]],
    [1425, [117]],
    [1435, [117]],
    [1406, [117]],
    [1416, [117]],
    [1426, [117]],
    [1436, [117]],
    [1437, [118]],
    [1447, [118]],
    [1457, [118]],
    [1467, [118]],
    [1438, [118]],
    [1448, [118]],
    [1458, [118]],
    [1468, [118]],
    [1439, [118]],
    [1449, [118]],
    [1459, [118]],
    [1469, [118]],
    [1440, [118]],
    [1450, [118]],
    [1460, [118]],
    [1470, [118]],
    [1441, [118]],
    [1451, [118]],
    [1461, [118]],
    [1471, [118]],
    [1442, [118]],
    [1452, [118]],
    [1462, [118]],
    [1472, [118]],
    [1443, [118]],
    [1453, [118]],
    [1463, [118]],
    [1473, [118]],
    [1444, [118]],
    [1454, [118]],
    [1464, [118]],
    [1474, [118]],
    [1445, [118]],
    [1455, [118]],
    [1465, [118]],
    [1475, [118]],
    [1446, [118]],
    [1456, [118]],
    [1466, [118]],
    [1476, [118]],
    [1237, [119]],
    [1247, [119]],
    [1238, [119]],
    [1248, [119]],
    [1239, [119]],
    [1249, [119]],
    [1240, [119]],
    [1250, [119]],
    [1241, [119]],
    [1251, [119]],
    [1242, [119]],
    [1252, [119]],
    [1243, [119]],
    [1253, [119]],
    [1244, [119]],
    [1254, [119]],
    [1245, [119]],
    [1255, [119]],
    [1246, [119]],
    [1256, [119]],
    [1257, [120]],
    [1258, [120]],
    [1259, [120]],
    [1260, [120]],
    [1261, [120]],
    [1262, [120]],
    [1263, [120]],
    [1264, [120]],
    [1265, [120]],
    [1266, [120]],
    [1267, [121]],
    [1268, [121]],
    [1269, [121]],
    [1270, [121]],
    [1271, [121]],
    [1272, [121]],
    [1273, [121]],
    [1274, [121]],
    [1275, [121]],
    [1276, [121]],
    [2010, [132]],
    [2011, [132]],
    [2025, [132]],
    [2012, [132]],
    [2026, [132]],
    [2039, [132]],
    [2013, [132]],
    [2027, [132]],
    [2040, [132]],
    [2052, [132]],
    [2014, [132]],
    [2028, [132]],
    [2041, [132]],
    [2053, [132]],
    [2015, [132]],
    [2029, [132]],
    [2042, [132]],
    [2054, [132]],
    [2064, [132]],
    [2016, [132]],
    [2030, [132]],
    [2043, [132]],
    [2055, [132]],
    [2065, [132]],
    [2074, [132]],
    [2017, [132]],
    [2031, [132]],
    [2044, [132]],
    [2056, [132]],
    [2066, [132]],
    [2075, [132]],
    [2018, [132]],
    [2032, [132]],
    [2045, [132]],
    [2057, [132]],
    [2067, [132]],
    [2076, [132]],
    [2019, [132]],
    [2033, [132]],
    [2046, [132]],
    [2058, [132]],
    [2068, [132]],
    [2077, [132]],
    [2020, [132]],
    [2034, [132]],
    [2047, [132]],
    [2059, [132]],
    [2069, [132]],
    [2078, [132]],
    [2021, [132]],
    [2035, [132]],
    [2048, [132]],
    [2060, [132]],
    [2070, [132]],
    [2079, [132]],
    [2022, [132]],
    [2036, [132]],
    [2049, [132]],
    [2061, [132]],
    [2071, [132]],
    [2080, [132]],
    [2023, [132]],
    [2037, [132]],
    [2050, [132]],
    [2062, [132]],
    [2072, [132]],
    [2081, [132]],
    [2024, [132]],
    [2038, [132]],
    [2051, [132]],
    [2063, [132]],
    [2073, [132]],
    [2082, [132]],
    [1716, [136]],
    [1726, [136]],
    [1714, [136]],
    [1715, [136]],
    [938, [136]],
    [1717, [136]],
    [1727, [136]],
    [1736, [136]],
    [1745, [136]],
    [1718, [136]],
    [1728, [136]],
    [1737, [136]],
    [1746, [136]],
    [1754, [136]],
    [1762, [136]],
    [1719, [136]],
    [1729, [136]],
    [1738, [136]],
    [1747, [136]],
    [1755, [136]],
    [1763, [136]],
    [1720, [136]],
    [1730, [136]],
    [1739, [136]],
    [1748, [136]],
    [1756, [136]],
    [1764, [136]],
    [1721, [136]],
    [1731, [136]],
    [1740, [136]],
    [1749, [136]],
    [1757, [136]],
    [1765, [136]],
    [1722, [136]],
    [1732, [136]],
    [1741, [136]],
    [1750, [136]],
    [1758, [136]],
    [1766, [136]],
    [1723, [136]],
    [1733, [136]],
    [1742, [136]],
    [1751, [136]],
    [1759, [136]],
    [1767, [136]],
    [1724, [136]],
    [1734, [136]],
    [1743, [136]],
    [1752, [136]],
    [1760, [136]],
    [1768, [136]],
    [1725, [136]],
    [1735, [136]],
    [1744, [136]],
    [1753, [136]],
    [1761, [136]],
    [1769, [136]],
    [1810, [140]],
    [1820, [140]],
    [1830, [140]],
    [1840, [140]],
    [1811, [140]],
    [1821, [140]],
    [1831, [140]],
    [1841, [140]],
    [1812, [140]],
    [1822, [140]],
    [1832, [140]],
    [1842, [140]],
    [1813, [140]],
    [1823, [140]],
    [1833, [140]],
    [1843, [140]],
    [1814, [140]],
    [1824, [140]],
    [1834, [140]],
    [1844, [140]],
    [1815, [140]],
    [1825, [140]],
    [1835, [140]],
    [1845, [140]],
    [1816, [140]],
    [1826, [140]],
    [1836, [140]],
    [1846, [140]],
    [1817, [140]],
    [1827, [140]],
    [1837, [140]],
    [1847, [140]],
    [1818, [140]],
    [1828, [140]],
    [1838, [140]],
    [1848, [140]],
    [1819, [140]],
    [1829, [140]],
    [1839, [140]],
    [1849, [140]],
    [1850, [141]],
    [1860, [141]],
    [1870, [141]],
    [1880, [141]],
    [1851, [141]],
    [1861, [141]],
    [1871, [141]],
    [1881, [141]],
    [1852, [141]],
    [1862, [141]],
    [1872, [141]],
    [1882, [141]],
    [1853, [141]],
    [1863, [141]],
    [1873, [141]],
    [1883, [141]],
    [1854, [141]],
    [1864, [141]],
    [1874, [141]],
    [1884, [141]],
    [1855, [141]],
    [1865, [141]],
    [1875, [141]],
    [1885, [141]],
    [1856, [141]],
    [1866, [141]],
    [1876, [141]],
    [1886, [141]],
    [1857, [141]],
    [1867, [141]],
    [1877, [141]],
    [1887, [141]],
    [1858, [141]],
    [1868, [141]],
    [1878, [141]],
    [1888, [141]],
    [1859, [141]],
    [1869, [141]],
    [1879, [141]],
    [1889, [141]],
    [1890, [142]],
    [1900, [142]],
    [1910, [142]],
    [1920, [142]],
    [1891, [142]],
    [1901, [142]],
    [1911, [142]],
    [1921, [142]],
    [1892, [142]],
    [1902, [142]],
    [1912, [142]],
    [1922, [142]],
    [1893, [142]],
    [1903, [142]],
    [1913, [142]],
    [1923, [142]],
    [1894, [142]],
    [1904, [142]],
    [1914, [142]],
    [1924, [142]],
    [1895, [142]],
    [1905, [142]],
    [1915, [142]],
    [1925, [142]],
    [1896, [142]],
    [1906, [142]],
    [1916, [142]],
    [1926, [142]],
    [1897, [142]],
    [1907, [142]],
    [1917, [142]],
    [1927, [142]],
    [1898, [142]],
    [1908, [142]],
    [1918, [142]],
    [1928, [142]],
    [1899, [142]],
    [1909, [142]],
    [1919, [142]],
    [1929, [142]],
    [1930, [143]],
    [1940, [143]],
    [1950, [143]],
    [1960, [143]],
    [1931, [143]],
    [1941, [143]],
    [1951, [143]],
    [1961, [143]],
    [1932, [143]],
    [1942, [143]],
    [1952, [143]],
    [1962, [143]],
    [1933, [143]],
    [1943, [143]],
    [1953, [143]],
    [1963, [143]],
    [1934, [143]],
    [1944, [143]],
    [1954, [143]],
    [1964, [143]],
    [1935, [143]],
    [1945, [143]],
    [1955, [143]],
    [1965, [143]],
    [1936, [143]],
    [1946, [143]],
    [1956, [143]],
    [1966, [143]],
    [1937, [143]],
    [1947, [143]],
    [1957, [143]],
    [1967, [143]],
    [1938, [143]],
    [1948, [143]],
    [1958, [143]],
    [1968, [143]],
    [1939, [143]],
    [1949, [143]],
    [1959, [143]],
    [1969, [143]],
    [1970, [144]],
    [1980, [144]],
    [1990, [144]],
    [2000, [144]],
    [1971, [144]],
    [1981, [144]],
    [1991, [144]],
    [2001, [144]],
    [1972, [144]],
    [1982, [144]],
    [1992, [144]],
    [2002, [144]],
    [1973, [144]],
    [1983, [144]],
    [1993, [144]],
    [2003, [144]],
    [1974, [144]],
    [1984, [144]],
    [1994, [144]],
    [2004, [144]],
    [1975, [144]],
    [1985, [144]],
    [1995, [144]],
    [2005, [144]],
    [1976, [144]],
    [1986, [144]],
    [1996, [144]],
    [2006, [144]],
    [1977, [144]],
    [1987, [144]],
    [1997, [144]],
    [2007, [144]],
    [1978, [144]],
    [1988, [144]],
    [1998, [144]],
    [2008, [144]],
    [1979, [144]],
    [1989, [144]],
    [1999, [144]],
    [2009, [144]],
    [1770, [145]],
    [1780, [145]],
    [1771, [145]],
    [1781, [145]],
    [1772, [145]],
    [1782, [145]],
    [1773, [145]],
    [1783, [145]],
    [1774, [145]],
    [1784, [145]],
    [1775, [145]],
    [1785, [145]],
    [1776, [145]],
    [1786, [145]],
    [1777, [145]],
    [1787, [145]],
    [1778, [145]],
    [1788, [145]],
    [1779, [145]],
    [1789, [145]],
    [1790, [146]],
    [1791, [146]],
    [1792, [146]],
    [1793, [146]],
    [1794, [146]],
    [1795, [146]],
    [1796, [146]],
    [1797, [146]],
    [1798, [146]],
    [1799, [146]],
    [1800, [147]],
    [1801, [147]],
    [1802, [147]],
    [1803, [147]],
    [1804, [147]],
    [1805, [147]],
    [1806, [147]],
    [1807, [147]],
    [1808, [147]],
    [1809, [147]],
    [2715, [166]],
    [2716, [166]],
    [2730, [166]],
    [2717, [166]],
    [2731, [166]],
    [2744, [166]],
    [2718, [166]],
    [2732, [166]],
    [2745, [166]],
    [2757, [166]],
    [2719, [166]],
    [2733, [166]],
    [2746, [166]],
    [2758, [166]],
    [2720, [166]],
    [2734, [166]],
    [2747, [166]],
    [2759, [166]],
    [2769, [166]],
    [2721, [166]],
    [2735, [166]],
    [2748, [166]],
    [2760, [166]],
    [2770, [166]],
    [2779, [166]],
    [2722, [166]],
    [2736, [166]],
    [2749, [166]],
    [2761, [166]],
    [2771, [166]],
    [2780, [166]],
    [2723, [166]],
    [2737, [166]],
    [2750, [166]],
    [2762, [166]],
    [2772, [166]],
    [2781, [166]],
    [2724, [166]],
    [2738, [166]],
    [2751, [166]],
    [2763, [166]],
    [2773, [166]],
    [2782, [166]],
    [2725, [166]],
    [2739, [166]],
    [2752, [166]],
    [2764, [166]],
    [2774, [166]],
    [2783, [166]],
    [2726, [166]],
    [2740, [166]],
    [2753, [166]],
    [2765, [166]],
    [2775, [166]],
    [2784, [166]],
    [2727, [166]],
    [2741, [166]],
    [2754, [166]],
    [2766, [166]],
    [2776, [166]],
    [2785, [166]],
    [2728, [166]],
    [2742, [166]],
    [2755, [166]],
    [2767, [166]],
    [2777, [166]],
    [2786, [166]],
    [2729, [166]],
    [2743, [166]],
    [2756, [166]],
    [2768, [166]],
    [2778, [166]],
    [2787, [166]],
    [2421, [170]],
    [2431, [170]],
    [2418, [170]],
    [2419, [170]],
    [2420, [170]],
    [2422, [170]],
    [2432, [170]],
    [2441, [170]],
    [2450, [170]],
    [2423, [170]],
    [2433, [170]],
    [2442, [170]],
    [2451, [170]],
    [2459, [170]],
    [2467, [170]],
    [2424, [170]],
    [2434, [170]],
    [2443, [170]],
    [2452, [170]],
    [2460, [170]],
    [2468, [170]],
    [2425, [170]],
    [2435, [170]],
    [2444, [170]],
    [2453, [170]],
    [2461, [170]],
    [2469, [170]],
    [2426, [170]],
    [2436, [170]],
    [2445, [170]],
    [2454, [170]],
    [2462, [170]],
    [2470, [170]],
    [2427, [170]],
    [2437, [170]],
    [2446, [170]],
    [2455, [170]],
    [2463, [170]],
    [2471, [170]],
    [2428, [170]],
    [2438, [170]],
    [2447, [170]],
    [2456, [170]],
    [2464, [170]],
    [2472, [170]],
    [2429, [170]],
    [2439, [170]],
    [2448, [170]],
    [2457, [170]],
    [2465, [170]],
    [2473, [170]],
    [2430, [170]],
    [2440, [170]],
    [2449, [170]],
    [2458, [170]],
    [2466, [170]],
    [2474, [170]],
    [2515, [172]],
    [2525, [172]],
    [2535, [172]],
    [2545, [172]],
    [2516, [172]],
    [2526, [172]],
    [2536, [172]],
    [2546, [172]],
    [2517, [172]],
    [2527, [172]],
    [2537, [172]],
    [2547, [172]],
    [2518, [172]],
    [2528, [172]],
    [2538, [172]],
    [2548, [172]],
    [2519, [172]],
    [2529, [172]],
    [2539, [172]],
    [2549, [172]],
    [2520, [172]],
    [2530, [172]],
    [2540, [172]],
    [2550, [172]],
    [2521, [172]],
    [2531, [172]],
    [2541, [172]],
    [2551, [172]],
    [2522, [172]],
    [2532, [172]],
    [2542, [172]],
    [2552, [172]],
    [2523, [172]],
    [2533, [172]],
    [2543, [172]],
    [2553, [172]],
    [2524, [172]],
    [2534, [172]],
    [2544, [172]],
    [2554, [172]],
    [2555, [173]],
    [2565, [173]],
    [2575, [173]],
    [2585, [173]],
    [2556, [173]],
    [2566, [173]],
    [2576, [173]],
    [2586, [173]],
    [2557, [173]],
    [2567, [173]],
    [2577, [173]],
    [2587, [173]],
    [2558, [173]],
    [2568, [173]],
    [2578, [173]],
    [2588, [173]],
    [2559, [173]],
    [2569, [173]],
    [2579, [173]],
    [2589, [173]],
    [2560, [173]],
    [2570, [173]],
    [2580, [173]],
    [2590, [173]],
    [2561, [173]],
    [2571, [173]],
    [2581, [173]],
    [2591, [173]],
    [2562, [173]],
    [2572, [173]],
    [2582, [173]],
    [2592, [173]],
    [2563, [173]],
    [2573, [173]],
    [2583, [173]],
    [2593, [173]],
    [2564, [173]],
    [2574, [173]],
    [2584, [173]],
    [2594, [173]],
    [2595, [174]],
    [2605, [174]],
    [2615, [174]],
    [2625, [174]],
    [2596, [174]],
    [2606, [174]],
    [2616, [174]],
    [2626, [174]],
    [2597, [174]],
    [2607, [174]],
    [2617, [174]],
    [2627, [174]],
    [2598, [174]],
    [2608, [174]],
    [2618, [174]],
    [2628, [174]],
    [2599, [174]],
    [2609, [174]],
    [2619, [174]],
    [2629, [174]],
    [2600, [174]],
    [2610, [174]],
    [2620, [174]],
    [2630, [174]],
    [2601, [174]],
    [2611, [174]],
    [2621, [174]],
    [2631, [174]],
    [2602, [174]],
    [2612, [174]],
    [2622, [174]],
    [2632, [174]],
    [2603, [174]],
    [2613, [174]],
    [2623, [174]],
    [2633, [174]],
    [2604, [174]],
    [2614, [174]],
    [2624, [174]],
    [2634, [174]],
    [2635, [175]],
    [2645, [175]],
    [2655, [175]],
    [2665, [175]],
    [2636, [175]],
    [2646, [175]],
    [2656, [175]],
    [2666, [175]],
    [2637, [175]],
    [2647, [175]],
    [2657, [175]],
    [2667, [175]],
    [2638, [175]],
    [2648, [175]],
    [2658, [175]],
    [2668, [175]],
    [2639, [175]],
    [2649, [175]],
    [2659, [175]],
    [2669, [175]],
    [2640, [175]],
    [2650, [175]],
    [2660, [175]],
    [2670, [175]],
    [2641, [175]],
    [2651, [175]],
    [2661, [175]],
    [2671, [175]],
    [2642, [175]],
    [2652, [175]],
    [2662, [175]],
    [2672, [175]],
    [2643, [175]],
    [2653, [175]],
    [2663, [175]],
    [2673, [175]],
    [2644, [175]],
    [2654, [175]],
    [2664, [175]],
    [2674, [175]],
    [2675, [176]],
    [2685, [176]],
    [2695, [176]],
    [2705, [176]],
    [2676, [176]],
    [2686, [176]],
    [2696, [176]],
    [2706, [176]],
    [2677, [176]],
    [2687, [176]],
    [2697, [176]],
    [2707, [176]],
    [2678, [176]],
    [2688, [176]],
    [2698, [176]],
    [2708, [176]],
    [2679, [176]],
    [2689, [176]],
    [2699, [176]],
    [2709, [176]],
    [2680, [176]],
    [2690, [176]],
    [2700, [176]],
    [2710, [176]],
    [2681, [176]],
    [2691, [176]],
    [2701, [176]],
    [2711, [176]],
    [2682, [176]],
    [2692, [176]],
    [2702, [176]],
    [2712, [176]],
    [2683, [176]],
    [2693, [176]],
    [2703, [176]],
    [2713, [176]],
    [2684, [176]],
    [2694, [176]],
    [2704, [176]],
    [2714, [176]],
    [2475, [177]],
    [2485, [177]],
    [2476, [177]],
    [2486, [177]],
    [2477, [177]],
    [2487, [177]],
    [2478, [177]],
    [2488, [177]],
    [2479, [177]],
    [2489, [177]],
    [2480, [177]],
    [2490, [177]],
    [2481, [177]],
    [2491, [177]],
    [2482, [177]],
    [2492, [177]],
    [2483, [177]],
    [2493, [177]],
    [2484, [177]],
    [2494, [177]],
    [2495, [178]],
    [2496, [178]],
    [2497, [178]],
    [2498, [178]],
    [2499, [178]],
    [2500, [178]],
    [2501, [178]],
    [2502, [178]],
    [2503, [178]],
    [2504, [178]],
    [2505, [179]],
    [2506, [179]],
    [2507, [179]],
    [2508, [179]],
    [2509, [179]],
    [2510, [179]],
    [2511, [179]],
    [2512, [179]],
    [2513, [179]],
    [2514, [179]],
]);



//////////////////
// WEBPACK FOOTER
// ./src/features/balancing/types/buildingsByRecipeId.ts
// module id = 2397
// module chunks = 3